import { useRef, useEffect, useState } from 'react'
import SwipeableLogItem from '../components/SwipeableLogItem'
import Pressable from '../components/Pressable'
import LogContent from '../components/LogContent'
import { formatTimestamp } from '../utils/formatters'
import { isDocumentLog, getFilenameFromUrl } from '../utils/fileHelpers'

/* ── SF Symbol Filter Tab Icons ── */

const AllIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 13 13" fill="currentColor">
    <path d="M6.06445 7.62305C5.8125 7.62305 5.57227 7.54102 5.26758 7.35938L0.708984 4.7168C0.216797 4.42969 0 4.18359 0 3.81445C0 3.43945 0.216797 3.19922 0.708984 2.90625L5.26758 0.263672C5.57227 0.0878906 5.8125 0 6.06445 0C6.31055 0 6.55078 0.0878906 6.85547 0.263672L11.4141 2.90625C11.9062 3.19922 12.123 3.43945 12.123 3.81445C12.123 4.18359 11.9062 4.42969 11.4141 4.7168L6.85547 7.35938C6.55078 7.54102 6.31055 7.62305 6.06445 7.62305ZM6.06445 12.5098C5.8125 12.5098 5.57227 12.4219 5.26758 12.2461L0.708984 9.60352C0.216797 9.31641 0 9.07031 0 8.70117C0 8.32617 0.216797 8.08594 0.708984 7.79297L2.53711 6.73828L4.85156 8.08008C5.32031 8.34961 5.69531 8.45508 6.06445 8.45508C6.43359 8.45508 6.80273 8.34961 7.27148 8.08008L9.5918 6.73828L11.4141 7.79297C11.9062 8.08594 12.123 8.32617 12.123 8.70117C12.123 9.07031 11.9062 9.31641 11.4141 9.60352L6.85547 12.2461C6.55078 12.4219 6.31055 12.5098 6.06445 12.5098Z"/>
  </svg>
)

const FavouritesIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 14 13" fill="currentColor">
    <path d="M2.60742 12.4863C2.33203 12.2812 2.27344 11.9414 2.43164 11.4785L3.63867 7.89844L0.5625 5.68945C0.164062 5.4082 0 5.09766 0.111328 4.76953C0.222656 4.44727 0.527344 4.29492 1.01367 4.29492H4.78711L5.93555 0.720703C6.08789 0.251953 6.32812 0 6.66797 0C7.01367 0 7.25391 0.251953 7.40039 0.720703L8.54883 4.29492H12.3223C12.8086 4.29492 13.1191 4.44727 13.2305 4.76953C13.3418 5.09766 13.1719 5.4082 12.7793 5.68945L9.70312 7.89844L10.9043 11.4785C11.0625 11.9414 11.0039 12.2812 10.7344 12.4863C10.459 12.6973 10.1133 12.627 9.71484 12.3398L6.66797 10.1016L3.62109 12.3398C3.22266 12.627 2.88281 12.6973 2.60742 12.4863Z"/>
  </svg>
)

const TextIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 14 9" fill="currentColor">
    <path d="M0.650391 8.78906C0.246094 8.78906 0 8.55469 0 8.16797C0 8.04492 0.0234375 7.92188 0.0761719 7.76953L2.68945 0.726562C2.85938 0.240234 3.19336 0 3.70312 0C4.23633 0 4.56445 0.240234 4.74609 0.732422L7.3418 7.74023C7.39453 7.89844 7.41797 8.01562 7.41797 8.15625C7.41797 8.54297 7.1543 8.78906 6.74414 8.78906C6.35742 8.78906 6.15234 8.625 6.02344 8.21484L5.39648 6.38672H2.00391L1.37109 8.21484C1.24219 8.625 1.04297 8.78906 0.650391 8.78906ZM3.68555 1.49414L2.37305 5.30859H5.02734L3.7207 1.49414H3.68555ZM10.6289 8.79492C9.36914 8.79492 8.47852 8.02734 8.47852 6.87891C8.47852 5.75977 9.32812 5.0625 10.875 4.98047L12.6973 4.875V4.40039C12.6973 3.62695 12.1875 3.1582 11.3379 3.1582C10.6348 3.1582 10.1836 3.44531 9.83789 4.08398C9.7207 4.25977 9.55078 4.34766 9.33398 4.34766C9.01758 4.34766 8.80078 4.14258 8.80078 3.84375C8.80078 3.71484 8.83594 3.58008 8.90039 3.43359C9.23438 2.66016 10.1895 2.17383 11.3789 2.17383C12.9316 2.17383 13.9219 3.01172 13.9219 4.3125V8.17969C13.9219 8.57227 13.6758 8.80078 13.3242 8.80078C12.9785 8.80078 12.7383 8.58398 12.7324 8.22656V7.57031H12.7148C12.3516 8.32031 11.5137 8.79492 10.6289 8.79492ZM10.957 7.8457C11.9238 7.8457 12.6973 7.17188 12.6973 6.29297V5.70703L11.0391 5.81836C10.1836 5.87109 9.7207 6.25781 9.7207 6.83789C9.7207 7.44141 10.2246 7.8457 10.957 7.8457Z"/>
  </svg>
)

const LinkIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="currentColor">
    <path d="M6.4043 9.14648C5.72461 9.01758 5.26172 8.75977 4.91602 8.41992C3.46875 6.9668 3.47461 4.92773 4.91016 3.49219L6.94922 1.44727C8.38477 0.0117188 10.4238 0 11.877 1.45898C13.3301 2.91211 13.3242 4.95117 11.8828 6.38672L10.2012 8.0625C10.3008 7.61133 10.2422 7.08984 10.0605 6.66211L11.0625 5.6543C12.0527 4.66992 12.0586 3.27539 11.0566 2.27344C10.0664 1.2832 8.67188 1.2832 7.67578 2.27344L5.73047 4.21875C4.74609 5.20312 4.74609 6.60938 5.73633 7.59961C6.09961 7.96289 6.5918 8.18555 7.29492 8.25L6.4043 9.14648ZM6.92578 4.20703C7.60547 4.33594 8.06836 4.59375 8.4082 4.93945C9.86133 6.38672 9.85547 8.42578 8.41406 9.86719L6.38086 11.9062C4.94531 13.3418 2.90625 13.3535 1.45312 11.9004C0 10.4473 0.00585938 8.40234 1.44727 6.9668L3.12305 5.29102C3.0293 5.74805 3.08789 6.26367 3.26953 6.69141L2.26758 7.69922C1.27734 8.68359 1.27148 10.084 2.27344 11.0801C3.26367 12.0703 4.6582 12.0703 5.64844 11.0801L7.59375 9.13477C8.58398 8.15039 8.58398 6.75 7.59375 5.75391C7.23047 5.39648 6.73242 5.16797 6.03516 5.10352L6.92578 4.20703Z"/>
  </svg>
)

const MediaIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 15 13" fill="currentColor">
    <path d="M4.88086 1.93359C3.14648 1.93359 2.10352 2.95898 2.10352 4.6875V9.375H1.89258C0.644531 9.36328 0 8.71875 0 7.4707V1.9043C0 0.650391 0.65625 0 1.92188 0H9.91992C11.1621 0 11.8184 0.632812 11.8359 1.85156V1.93359H4.88086ZM4.88086 12.1582C3.61523 12.1582 2.95898 11.5078 2.95898 10.2539V4.6875C2.95898 3.43945 3.61523 2.78906 4.88086 2.78906H12.8789C14.1445 2.78906 14.8008 3.43945 14.8008 4.6875V10.2539C14.8008 11.5078 14.1445 12.1582 12.8789 12.1582H4.88086ZM7.03711 7.58789C7.71094 7.58789 8.26758 7.03125 8.26758 6.35156C8.26758 5.67773 7.71094 5.10938 7.03711 5.10938C6.35742 5.10938 5.80078 5.67773 5.80078 6.35156C5.80078 7.03125 6.35742 7.58789 7.03711 7.58789ZM4.75781 11.1152H13.0195C13.4824 11.1152 13.7812 10.8281 13.7812 10.3477V9.62109L11.5664 7.55859C11.3379 7.34766 11.0742 7.24805 10.793 7.24805C10.5117 7.24805 10.2598 7.3418 10.0195 7.55273L7.70508 9.60938L6.77344 8.76562C6.5625 8.57812 6.32227 8.47852 6.07617 8.47852C5.85352 8.47852 5.625 8.57227 5.41406 8.76562L3.98438 10.0488V10.3418C3.98438 10.8223 4.27734 11.1152 4.75781 11.1152Z"/>
  </svg>
)

const VoiceIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 12 13" fill="currentColor">
    <path d="M4.54688 12.4863C4.25391 12.4863 4.03125 12.252 4.03125 11.9707V0.515625C4.03125 0.234375 4.25391 0 4.54688 0C4.83984 0 5.06836 0.234375 5.06836 0.515625V11.9707C5.06836 12.252 4.83984 12.4863 4.54688 12.4863ZM8.58398 11.1914C8.28516 11.1914 8.06836 10.9629 8.06836 10.6758V1.81055C8.06836 1.52344 8.28516 1.2832 8.58398 1.2832C8.87695 1.2832 9.09961 1.52344 9.09961 1.81055V10.6758C9.09961 10.9629 8.87695 11.1914 8.58398 11.1914ZM2.53125 10.207C2.23828 10.207 2.01562 9.97266 2.01562 9.69141V2.79492C2.01562 2.50781 2.23828 2.27344 2.53125 2.27344C2.82422 2.27344 3.05273 2.50781 3.05273 2.79492V9.69141C3.05273 9.97266 2.82422 10.207 2.53125 10.207ZM6.56836 9.44531C6.26953 9.44531 6.04688 9.2168 6.04688 8.93555V3.55078C6.04688 3.26367 6.26953 3.0293 6.56836 3.0293C6.85547 3.0293 7.08398 3.26367 7.08398 3.55078V8.93555C7.08398 9.2168 6.85547 9.44531 6.56836 9.44531ZM10.5996 8.30273C10.3066 8.30273 10.084 8.07422 10.084 7.78711V4.69922C10.084 4.41211 10.3066 4.17188 10.5996 4.17188C10.8926 4.17188 11.1211 4.41211 11.1211 4.69922V7.78711C11.1211 8.07422 10.8926 8.30273 10.5996 8.30273ZM0.509766 7.76953C0.222656 7.76953 0 7.53516 0 7.24805V5.23242C0 4.94531 0.222656 4.71094 0.509766 4.71094C0.808594 4.71094 1.03711 4.94531 1.03711 5.23242V7.24805C1.03711 7.53516 0.808594 7.76953 0.509766 7.76953Z"/>
  </svg>
)

const DocumentIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 14 11" fill="currentColor">
    <path d="M1.92188 10.916C0.65625 10.916 0 10.2656 0 9.01172V1.86914C0 0.638672 0.644531 0 1.74023 0H3.15234C3.76172 0 4.06641 0.111328 4.48242 0.451172L4.81641 0.720703C5.13867 0.984375 5.38477 1.08398 5.80664 1.08398H11.502C12.7676 1.08398 13.4238 1.73438 13.4238 2.98828V9.01172C13.4238 10.2656 12.7734 10.916 11.6543 10.916H1.92188ZM1.13086 3.17578H12.2812V2.82422C12.2812 2.44922 12.0117 2.21484 11.5664 2.21484H1.83984C1.39453 2.21484 1.13086 2.44922 1.13086 2.82422V3.17578Z"/>
  </svg>
)

/* CodeIcon — replaces PollsIcon (angle-bracket-with-dots SF symbol) */
const CodeIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 16 13" fill="currentColor">
    <path d="M0 6.12891C0 5.73047 0.234375 5.45508 0.679688 5.36719C1.41797 5.23828 1.7168 4.86914 1.7168 3.95508V2.46094C1.7168 0.779297 2.49023 0 4.125 0C4.27148 0 4.39453 0.0175781 4.5 0.0527344C4.77539 0.140625 4.91016 0.322266 4.91016 0.568359C4.91016 0.826172 4.79297 0.984375 4.57617 1.05469C4.51172 1.07812 4.42383 1.0957 4.33008 1.10156C3.39258 1.17188 3.04688 1.57031 3.04688 2.61328V4.42383C3.04688 5.43164 2.47852 6.01172 1.51758 6.11133C1.47656 6.11133 1.47656 6.16406 1.51758 6.16406C2.47852 6.26367 3.04688 6.84375 3.04688 7.85156V9.66211C3.04688 10.6992 3.39258 11.1035 4.33008 11.1797C4.40625 11.1855 4.4707 11.1973 4.53516 11.209C4.78711 11.2793 4.91016 11.4316 4.91016 11.7012C4.91016 11.9473 4.77539 12.1406 4.5 12.2285C4.41211 12.252 4.29492 12.2695 4.17188 12.2695C2.49609 12.2695 1.7168 11.502 1.7168 9.82031V8.32031C1.7168 7.40625 1.42383 7.03125 0.679688 6.90234C0.234375 6.82031 0 6.53906 0 6.12891ZM15.3398 6.12891C15.3398 6.53906 15.1055 6.82031 14.6602 6.90234C13.916 7.03125 13.623 7.40625 13.623 8.32031V9.82031C13.623 11.502 12.8496 12.2695 11.168 12.2695C11.0508 12.2695 10.9277 12.252 10.8398 12.2285C10.5645 12.1406 10.4297 11.9473 10.4297 11.7012C10.4297 11.4316 10.5527 11.2793 10.8047 11.209C10.8691 11.1973 10.9336 11.1855 11.0098 11.1797C11.9473 11.1035 12.293 10.6992 12.293 9.66211V7.85156C12.293 6.84375 12.8613 6.26367 13.8223 6.16406C13.8633 6.16406 13.8633 6.11133 13.8223 6.11133C12.8613 6.01172 12.293 5.43164 12.293 4.42383V2.61328C12.293 1.57031 11.9473 1.17188 11.0098 1.10156C10.916 1.0957 10.8281 1.07812 10.7637 1.05469C10.5469 0.984375 10.4297 0.826172 10.4297 0.568359C10.4297 0.322266 10.5645 0.140625 10.8398 0.0527344C10.9453 0.0175781 11.0684 0 11.2148 0C12.8496 0 13.623 0.779297 13.623 2.46094V3.95508C13.623 4.86914 13.9219 5.23828 14.6602 5.36719C15.1055 5.45508 15.3398 5.73047 15.3398 6.12891ZM4.94531 7.00781C4.45898 7.00781 4.06055 6.60938 4.06055 6.12305C4.06055 5.64258 4.45898 5.24414 4.94531 5.24414C5.41992 5.24414 5.82422 5.64258 5.82422 6.12305C5.82422 6.60938 5.42578 7.00781 4.94531 7.00781ZM7.69336 7.00781C7.20703 7.00781 6.81445 6.60938 6.81445 6.12305C6.81445 5.64258 7.20703 5.24414 7.69336 5.24414C8.17383 5.24414 8.57227 5.64258 8.57227 6.12305C8.57227 6.60938 8.17383 7.00781 7.69336 7.00781ZM10.4414 7.00781C9.95508 7.00781 9.5625 6.60938 9.5625 6.12305C9.5625 5.64258 9.95508 5.24414 10.4414 5.24414C10.9219 5.24414 11.3203 5.64258 11.3203 6.12305C11.3203 6.60938 10.9219 7.00781 10.4414 7.00781Z"/>
  </svg>
)

const EventIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 12 11" fill="currentColor">
    <path d="M1.92188 10.9395C0.65625 10.9395 0 10.2891 0 9.03516V1.9043C0 0.650391 0.65625 0 1.92188 0H9.98438C11.25 0 11.9062 0.650391 11.9062 1.9043V9.03516C11.9062 10.2832 11.25 10.9395 9.98438 10.9395H1.92188ZM1.9043 9.79102H9.99023C10.4824 9.79102 10.7578 9.5332 10.7578 9.02344V3.60938C10.7578 3.09375 10.4824 2.8418 9.99023 2.8418H1.9043C1.41797 2.8418 1.14844 3.09375 1.14844 3.60938V9.02344C1.14844 9.5332 1.41797 9.79102 1.9043 9.79102ZM4.82227 4.875C4.61719 4.875 4.54688 4.81055 4.54688 4.59961V4.25977C4.54688 4.04883 4.61719 3.98438 4.82227 3.98438H5.16797C5.37891 3.98438 5.44922 4.04883 5.44922 4.25977V4.59961C5.44922 4.81055 5.37891 4.875 5.16797 4.875H4.82227ZM6.74414 4.875C6.5332 4.875 6.46289 4.81055 6.46289 4.59961V4.25977C6.46289 4.04883 6.5332 3.98438 6.74414 3.98438H7.08398C7.29492 3.98438 7.36523 4.04883 7.36523 4.25977V4.59961C7.36523 4.81055 7.29492 4.875 7.08398 4.875H6.74414ZM8.66016 4.875C8.44922 4.875 8.37891 4.81055 8.37891 4.59961V4.25977C8.37891 4.04883 8.44922 3.98438 8.66016 3.98438H9C9.21094 3.98438 9.28125 4.04883 9.28125 4.25977V4.59961C9.28125 4.81055 9.21094 4.875 9 4.875H8.66016ZM2.90625 6.76172C2.70117 6.76172 2.63086 6.69727 2.63086 6.48633V6.14648C2.63086 5.93555 2.70117 5.87109 2.90625 5.87109H3.25195C3.46289 5.87109 3.5332 5.93555 3.5332 6.14648V6.48633C3.5332 6.69727 3.46289 6.76172 3.25195 6.76172H2.90625ZM4.82227 6.76172C4.61719 6.76172 4.54688 6.69727 4.54688 6.48633V6.14648C4.54688 5.93555 4.61719 5.87109 4.82227 5.87109H5.16797C5.37891 5.87109 5.44922 5.93555 5.44922 6.14648V6.48633C5.44922 6.69727 5.37891 6.76172 5.16797 6.76172H4.82227ZM6.74414 6.76172C6.5332 6.76172 6.46289 6.69727 6.46289 6.48633V6.14648C6.46289 5.93555 6.5332 5.87109 6.74414 5.87109H7.08398C7.29492 5.87109 7.36523 5.93555 7.36523 6.14648V6.48633C7.36523 6.69727 7.36523 6.76172 7.08398 6.76172H6.74414ZM8.66016 6.76172C8.44922 6.76172 8.37891 6.69727 8.37891 6.48633V6.14648C8.37891 5.93555 8.44922 5.87109 8.66016 5.87109H9C9.21094 5.87109 9.28125 5.93555 9.28125 6.14648V6.48633C9.28125 6.69727 9.28125 6.76172 9 6.76172H8.66016ZM2.90625 8.64844C2.70117 8.64844 2.63086 8.58398 2.63086 8.37305V8.0332C2.63086 7.82227 2.70117 7.75781 2.90625 7.75781H3.25195C3.46289 7.75781 3.5332 7.82227 3.5332 8.0332V8.37305C3.5332 8.58398 3.46289 8.64844 3.25195 8.64844H2.90625ZM4.82227 8.64844C4.61719 8.64844 4.54688 8.58398 4.54688 8.37305V8.0332C4.54688 7.82227 4.61719 7.75781 4.82227 7.75781H5.16797C5.37891 7.75781 5.44922 7.82227 5.44922 8.0332V8.37305C5.44922 8.58398 5.37891 8.64844 5.16797 8.64844H4.82227ZM6.74414 8.64844C6.5332 8.64844 6.46289 8.58398 6.46289 8.37305V8.0332C6.46289 7.82227 6.5332 7.75781 6.74414 7.75781H7.08398C7.29492 7.75781 7.36523 7.82227 7.36523 8.0332V8.37305C7.36523 8.58398 7.36523 8.64844 7.08398 8.64844H6.74414ZM8.66016 8.64844C8.44922 8.64844 8.37891 8.58398 8.37891 8.37305V8.0332C8.37891 7.82227 8.44922 7.75781 8.66016 7.75781H9C9.21094 7.75781 9.28125 7.82227 9.28125 8.0332V8.37305C9.28125 8.58398 9.28125 8.64844 9 8.64844H8.66016Z"/>
  </svg>
)

/* ── Select-mode icons ── */
const SelectListIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.46875 0.943359C0.205078 0.943359 0 0.738281 0 0.474609C0 0.210938 0.205078 0 0.46875 0H11.3848C11.6484 0 11.8535 0.210938 11.8535 0.474609C11.8535 0.738281 11.6484 0.943359 11.3848 0.943359H0.46875ZM1.70508 3.96094C1.44141 3.96094 1.23047 3.75586 1.23047 3.49219C1.23047 3.22852 1.44141 3.01758 1.70508 3.01758H10.1836C10.4473 3.01758 10.6523 3.22852 10.6523 3.49219C10.6523 3.75586 10.4473 3.96094 10.1836 3.96094H1.70508ZM2.90625 6.97852C2.64258 6.97852 2.4375 6.77344 2.4375 6.50977C2.4375 6.24609 2.64258 6.03516 2.90625 6.03516H8.97656C9.24023 6.03516 9.45117 6.24609 9.45117 6.50977C9.45117 6.77344 9.24023 6.97852 8.97656 6.97852H2.90625Z" fill="white"/>
  </svg>
)

const XMarkIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9.19336 8.45508C9.39258 8.6543 9.39258 8.98828 9.19336 9.19336C8.99414 9.39844 8.64844 9.39258 8.44922 9.19336L4.69922 5.44336L0.949219 9.19336C0.75 9.39258 0.410156 9.39258 0.205078 9.19336C0 8.99414 0.00585938 8.6543 0.205078 8.45508L3.95508 4.69922L0.205078 0.949219C0.00585938 0.75 0.00585938 0.416016 0.205078 0.210938C0.404297 0 0.75 0.00585938 0.949219 0.210938L4.69922 3.96094L8.44922 0.210938C8.6543 0 8.98828 0.00585938 9.19336 0.210938C9.39844 0.410156 9.39258 0.75 9.19336 0.949219L5.44336 4.69922L9.19336 8.45508Z" fill="white"/>
  </svg>
)

const EllipsisIcon = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 17 4" fill="#fff"><circle cx="2" cy="2" r="2"/><circle cx="8.5" cy="2" r="2"/><circle cx="15" cy="2" r="2"/></svg>
)

/* Star — outline (unfilled) and filled, for the card's tap-to-fill animation */
const StarOutlineIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 14 13" fill="#fff">
    <path d="M2.60742 12.4863C2.33203 12.2812 2.27344 11.9414 2.43164 11.4785L3.63867 7.89844L0.5625 5.68945C0.164062 5.4082 0 5.09766 0.111328 4.76953C0.222656 4.44727 0.527344 4.28906 1.01367 4.29492L4.78711 4.31836L5.93555 0.720703C6.08789 0.251953 6.32812 0 6.66797 0C7.01367 0 7.25391 0.251953 7.40039 0.720703L8.54883 4.31836L12.3223 4.29492C12.8086 4.28906 13.1191 4.44727 13.2305 4.76953C13.3418 5.09766 13.1719 5.4082 12.7793 5.68945L9.70312 7.89844L10.9043 11.4785C11.0625 11.9414 11.0039 12.2812 10.7344 12.4863C10.459 12.6973 10.1133 12.627 9.71484 12.3398L6.66797 10.1016L3.62109 12.3398C3.22266 12.627 2.88281 12.6973 2.60742 12.4863ZM3.63281 11.0742C3.64453 11.0918 3.66211 11.0801 3.68555 11.0684L6.32812 9.0293C6.5625 8.8418 6.77344 8.8418 7.01367 9.0293L9.65625 11.0684C9.67969 11.0801 9.69141 11.0918 9.70312 11.0742C9.71484 11.0625 9.71484 11.0566 9.70312 11.0273L8.58984 7.88086C8.49023 7.59375 8.52539 7.41797 8.79492 7.23633L11.543 5.34961C11.5723 5.33203 11.5781 5.32617 11.5723 5.30859C11.5664 5.29688 11.5547 5.29102 11.5195 5.29102L8.18555 5.36719C7.88672 5.37891 7.72852 5.2793 7.64062 4.98633L6.70312 1.78711C6.69141 1.75195 6.68555 1.74609 6.66797 1.74609C6.65625 1.74609 6.64453 1.75195 6.63867 1.78711L5.69531 4.98633C5.60742 5.2793 5.45508 5.37891 5.15039 5.36719L1.81641 5.29102C1.78711 5.29102 1.77539 5.29688 1.76367 5.30859C1.75781 5.32617 1.76953 5.33789 1.79297 5.34961L4.54688 7.23633C4.81055 7.41211 4.8457 7.59375 4.74609 7.88086L3.63281 11.0273C3.62695 11.0566 3.62695 11.0625 3.63281 11.0742Z"/>
  </svg>
)
const StarFilledIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 14 13" fill="#fff">
    <path d="M2.60742 12.4863C2.33203 12.2812 2.27344 11.9414 2.43164 11.4785L3.63867 7.89844L0.5625 5.68945C0.164062 5.4082 0 5.09766 0.111328 4.76953C0.222656 4.44727 0.527344 4.29492 1.01367 4.29492H4.78711L5.93555 0.720703C6.08789 0.251953 6.32812 0 6.66797 0C7.01367 0 7.25391 0.251953 7.40039 0.720703L8.54883 4.29492H12.3223C12.8086 4.29492 13.1191 4.44727 13.2305 4.76953C13.3418 5.09766 13.1719 5.4082 12.7793 5.68945L9.70312 7.89844L10.9043 11.4785C11.0625 11.9414 11.0039 12.2812 10.7344 12.4863C10.459 12.6973 10.1133 12.627 9.71484 12.3398L6.66797 10.1016L3.62109 12.3398C3.22266 12.627 2.88281 12.6973 2.60742 12.4863Z"/>
  </svg>
)

/* Trash — outline style matching the app's trash icon (image 5) */
const TrashOutlineIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 12 14" fill="#FF453A">
    <path d="M3.08789 13.2246C2.17969 13.2246 1.60547 12.6855 1.56445 11.7832L1.16602 3.33398H0.515625C0.234375 3.33398 0 3.11133 0 2.81836C0 2.53125 0.234375 2.30859 0.515625 2.30859H3.11719V1.42969C3.11719 0.533203 3.69141 0 4.6582 0H6.88477C7.85742 0 8.42578 0.533203 8.42578 1.42969V2.30859H11.0332C11.3262 2.30859 11.5547 2.53125 11.5547 2.81836C11.5547 3.11133 11.3262 3.33398 11.0332 3.33398H10.3887L9.99023 11.7773C9.94922 12.6797 9.36914 13.2246 8.47266 13.2246H3.08789ZM4.19531 1.48242V2.30859H7.34766V1.48242C7.34766 1.17773 7.13672 0.984375 6.80859 0.984375H4.73438C4.40625 0.984375 4.19531 1.17773 4.19531 1.48242ZM3.19922 12.1875H8.34375C8.67773 12.1875 8.91211 11.9531 8.92383 11.6074L9.30469 3.33398H2.22656L2.625 11.6074C2.64258 11.9531 2.87695 12.1875 3.19922 12.1875ZM4.04883 11.2441C3.81445 11.2441 3.65039 11.0918 3.64453 10.8574L3.46875 4.7168C3.46289 4.48828 3.62109 4.33008 3.86719 4.33008C4.10156 4.33008 4.26562 4.48242 4.27148 4.7168L4.44727 10.8574C4.45312 11.0859 4.29492 11.2441 4.04883 11.2441ZM5.77734 11.2441C5.53125 11.2441 5.36719 11.0859 5.36719 10.8574V4.7168C5.36719 4.48828 5.53125 4.33008 5.77734 4.33008C6.02344 4.33008 6.1875 4.48828 6.1875 4.7168V10.8574C6.1875 11.0859 6.02344 11.2441 5.77734 11.2441ZM7.50586 11.2441C7.25977 11.2441 7.0957 11.0859 7.10156 10.8574L7.2832 4.7168C7.28906 4.48242 7.45312 4.33008 7.6875 4.33008C7.92773 4.33008 8.0918 4.48828 8.08594 4.7168L7.9043 10.8574C7.89844 11.0918 7.74023 11.2441 7.50586 11.2441Z"/>
  </svg>
)

/* ── Filter tab config: key, label, icon ── */
const filterTabConfig = [
  { key: 'All', label: 'All', icon: AllIcon },
  { key: 'Favourites', label: 'Favourite', icon: FavouritesIcon },
  { key: 'Text', label: 'Text', icon: TextIcon },
  { key: 'Links', label: 'Links', icon: LinkIcon },
  { key: 'Media', label: 'Media', icon: MediaIcon },
  { key: 'Voice', label: 'Voice Memo', icon: VoiceIcon },
  { key: 'Documents', label: 'Document', icon: DocumentIcon },
  { key: 'Code', label: 'Code', icon: CodeIcon },
  { key: 'Events', label: 'Event', icon: EventIcon },
]

const buildFavouriteLog = (log) => {
  if (!log) return null
  if (log.is_starred) return log
  const starredUrls = log.starred_urls || []
  if (starredUrls.length === 0) return null
  const allUrls = log.media_urls || (log.media_url ? [log.media_url] : [])
  const filteredUrls = allUrls.filter(u => starredUrls.includes(u))
  if (filteredUrls.length === 0) return null
  return { ...log, media_urls: filteredUrls, media_url: filteredUrls[0] }
}

/* ── Scroll helpers ── */
const scrollToNewest = (el, isMediaView) => {
  if (!el) return
  if (isMediaView) {
    if (el.scrollHeight > el.clientHeight)
      el.scrollTo({ top: el.scrollHeight - el.clientHeight, behavior: 'smooth' })
  } else {
    el.scrollTo({ top: 0, behavior: 'smooth' })
  }
}

function LibraryPage({ logs, session, libraryScrollRef, libraryFilter, setLibraryFilter, searchQuery, setSearchQuery, profilePhotoUrl, onDeleteConfirm, onToggleStar, onToggleLogStarFull, onStarLogs, onUnstarLogs, onDeleteLogs, onSelectModeChange, onVotePoll, onEditEvent, onEditPoll, onEditCode, onImageClick, onGalleryClick, onVideoClick, onDocOpen, expandedLogs, setExpandedLogs, getLogIcon, libraryNavClickSignal }) {

  useEffect(() => {
    if (!libraryFilter) setLibraryFilter('All')
  }, [])

  /* ── SELECT MODE state (local to Library, All filter only) ── */
  const [selectMode, setSelectMode] = useState(false)
  const [selectedIds, setSelectedIds] = useState(() => new Set())
  const [showActionCard, setShowActionCard] = useState(false)
  const [confirmDelete, setConfirmDelete] = useState(false)
  const [deleteAnimating, setDeleteAnimating] = useState(false)   // press animation on Delete button
  const [starFilled, setStarFilled] = useState(false)     // card star icon fill state
  const [starAnimating, setStarAnimating] = useState(false)
  const [searchFocused, setSearchFocused] = useState(false)   // search bar focus glow

  // Tell App to hide the nav bar while selecting (floating pill replaces it).
  useEffect(() => {
    onSelectModeChange && onSelectModeChange(selectMode)
  }, [selectMode])

  // Leaving the All filter cancels select mode entirely.
  useEffect(() => {
    if (libraryFilter !== 'All' && selectMode) {
      setSelectMode(false)
      setSelectedIds(new Set())
      setShowActionCard(false)
    }
  }, [libraryFilter])

  const enterSelectMode = () => { setSelectMode(true); setSelectedIds(new Set()); setShowActionCard(false); setStarFilled(false); setStarAnimating(false) }
  const exitSelectMode = () => { setSelectMode(false); setSelectedIds(new Set()); setShowActionCard(false); setConfirmDelete(false); setStarFilled(false); setStarAnimating(false) }

  const toggleSelect = (id) => {
    setSelectedIds(prev => {
      const next = new Set(prev)
      if (next.has(id)) next.delete(id); else next.add(id)
      return next
    })
  }

  const selectedCount = selectedIds.size

  /* Are ALL selected logs already favourited? Drives the Star↔Unfavourite
   * label/icon swap. (False when nothing is selected.) */
  const selectedLogs = logs.filter(l => selectedIds.has(l.id))
  const allSelectedFav = selectedCount > 0 && selectedLogs.every(l => l.is_starred)

  // STAR / UNFAVOURITE — one batched call, then animate fill + close.
  const handleStarSelected = () => {
    if (selectedCount === 0 || starAnimating) return
    const ids = Array.from(selectedIds)
    setStarAnimating(true)

    if (allSelectedFav) {
      // All already favourites → unfavourite them all.
      setStarFilled(false)
      onUnstarLogs && onUnstarLogs(ids)
    } else {
      // Mixed or none favourited → favourite them all.
      setStarFilled(true)
      onStarLogs && onStarLogs(ids)
    }

    // brief beat so the icon-fill + "Favourited" label is visible, then close
    setTimeout(() => { setShowActionCard(false); exitSelectMode() }, 450)
  }

  // DELETE — single confirmation (our own notice), then ONE batched delete.
  const handleDeleteSelected = () => {
    setShowActionCard(false)
    setConfirmDelete(true)
  }
  const confirmDeleteSelected = () => {
    const ids = Array.from(selectedIds)
    onDeleteLogs && onDeleteLogs(ids)        // one DB call, all ids
    setConfirmDelete(false)
    exitSelectMode()
  }

  const filteredLogs = logs.slice().reverse().reduce((acc, log) => {
    if (libraryFilter === 'Favourites') {
      const favLog = buildFavouriteLog(log)
      if (!favLog) return acc
      acc.push(favLog)
      return acc
    } else if (libraryFilter === 'Text') {
      if (log.log_type !== 'text' || log.media_type || log.media_url || log.media_urls?.length > 0 || log.content?.match(/https?:\/\//)) return acc
    } else if (libraryFilter === 'Media') {
      if (!log.media_type?.startsWith('image/') && !log.media_type?.startsWith('video/')) return acc
    } else if (libraryFilter === 'Voice') {
      if (!log.media_type?.startsWith('audio/')) return acc
    } else if (libraryFilter === 'Links') {
      if (!log.content?.includes('http')) return acc
    } else if (libraryFilter === 'Documents') {
      if (!isDocumentLog(log)) return acc
    } else if (libraryFilter === 'Events') {
      if (log.log_type !== 'event') return acc
    } else if (libraryFilter === 'Code') {
      if (log.log_type !== 'code') return acc
    }

    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase()
      const fn = log.content || getFilenameFromUrl(log.media_url || log.media_urls?.[0])
      if (!log.content?.toLowerCase().includes(q) && !log.event_title?.toLowerCase().includes(q) && !log.event_description?.toLowerCase().includes(q) && !log.code_title?.toLowerCase().includes(q) && !fn?.toLowerCase().includes(q)) return acc
    }

    acc.push(log)
    return acc
  }, [])

  const mediaGridItems = filteredLogs.slice().reverse().flatMap(log => {
    const urls = log.media_urls || (log.media_url ? [log.media_url] : [])
    return urls.map(url => ({ url, log, isVideo: log.media_type?.startsWith('video/') }))
  })
  const mediaPhotos = mediaGridItems.filter(i => !i.isVideo).length
  const mediaVideos = mediaGridItems.filter(i => i.isVideo).length

  useEffect(() => {
    if (libraryFilter === 'Media' && libraryScrollRef.current) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => scrollToNewest(libraryScrollRef.current, true))
      })
    }
  }, [libraryFilter, logs])

  useEffect(() => {
    if (libraryNavClickSignal === undefined) return
    const isMediaView = libraryFilter === 'Media'
    requestAnimationFrame(() => {
      requestAnimationFrame(() => scrollToNewest(libraryScrollRef.current, isMediaView))
    })
  }, [libraryNavClickSignal])

  const renderLogContent = (log) => (
    <LogContent
      log={log} session={session} profilePhotoUrl={profilePhotoUrl}
      onVotePoll={onVotePoll} onEditEvent={onEditEvent} onEditPoll={onEditPoll} onEditCode={onEditCode}
      onImageClick={onImageClick} onGalleryClick={onGalleryClick}
      onVideoClick={onVideoClick} onDocOpen={onDocOpen}
      expandedLogs={expandedLogs} setExpandedLogs={setExpandedLogs}
    />
  )

  /* Search bar — shrinks to make room for the Select button (All filter only). */
  const showSelectButton = libraryFilter === 'All'

  const searchBar = (
    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '14px' }}>
      <div style={{
        flex: 1,
        minWidth: 0,
        padding: '10px 16px',
        background: 'var(--glass-bg)',
        backdropFilter: 'saturate(var(--glass-saturation)) blur(var(--glass-blur))',
        WebkitBackdropFilter: 'saturate(var(--glass-saturation)) blur(var(--glass-blur))',
        borderRadius: 'var(--radius-pill)',
        border: searchFocused ? '0.5px solid rgba(0,123,255,0.5)' : 'var(--border-glass)',
        boxShadow: searchFocused ? '0 0 0 3px rgba(0,123,255,0.12), var(--glass-shadow)' : 'var(--glass-shadow)',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        transition: 'border 0.25s ease, box-shadow 0.25s ease',
      }}>
        <svg width="18" height="18" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0, transition: 'transform 0.25s cubic-bezier(0.34,1.3,0.64,1)', transform: searchFocused ? 'scale(1.08)' : 'scale(1)' }}>
          <path d="M0 4.76953C0 2.13867 2.13867 0 4.76953 0C7.40039 0 9.53906 2.13867 9.53906 4.76953C9.53906 5.79492 9.20508 6.74414 8.64844 7.51172L11.3262 10.1953C11.4844 10.3594 11.5664 10.5762 11.5664 10.8105C11.5664 11.2969 11.209 11.6719 10.7109 11.6719C10.4824 11.6719 10.2539 11.5957 10.0898 11.4258L7.39453 8.73047C6.64453 9.24023 5.74805 9.53906 4.76953 9.53906C2.13867 9.53906 0 7.40039 0 4.76953ZM1.21875 4.76953C1.21875 6.73242 2.80664 8.32031 4.76953 8.32031C6.73242 8.32031 8.32031 6.73242 8.32031 4.76953C8.32031 2.80664 6.73242 1.21875 4.76953 1.21875C2.80664 1.21875 1.21875 2.80664 1.21875 4.76953Z" fill="var(--color-text-secondary)"/>
        </svg>
        <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} onFocus={() => setSearchFocused(true)} onBlur={() => setSearchFocused(false)} placeholder="Search" style={{ background: 'none', border: 'none', color: 'var(--color-text-primary)', fontSize: 'var(--text-lg)', outline: 'none', flex: 1, minWidth: 0, fontFamily: 'var(--font-system)' }} />
        {searchQuery.length > 0 && (
          <Pressable onPress={() => setSearchQuery('')} pressScale={0.85} style={{ width: '20px', height: '20px', borderRadius: '10px', background: 'rgba(142,142,147,0.5)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, padding: 0, animation: 'lib-clear-in 0.22s cubic-bezier(0.34,1.4,0.64,1)' }}>
            <svg width="8" height="8" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.19336 8.45508C9.39258 8.6543 9.39258 8.98828 9.19336 9.19336C8.99414 9.39844 8.64844 9.39258 8.44922 9.19336L4.69922 5.44336L0.949219 9.19336C0.75 9.39258 0.410156 9.39258 0.205078 9.19336C0 8.99414 0.00585938 8.6543 0.205078 8.45508L3.95508 4.69922L0.205078 0.949219C0.00585938 0.75 0.00585938 0.416016 0.205078 0.210938C0.404297 0 0.75 0.00585938 0.949219 0.210938L4.69922 3.96094L8.44922 0.210938C8.6543 0 8.98828 0.00585938 9.19336 0.210938C9.39844 0.410156 9.39258 0.75 9.19336 0.949219L5.44336 4.69922L9.19336 8.45508Z" fill="white"/>
            </svg>
          </Pressable>
        )}
      </div>

      {/* SELECT button — only on the All filter. Just a circle with the
          select icon. Once in select mode it does nothing (the floating
          X pill is what cancels); it stays as a static circle. */}
      {showSelectButton && (
        <Pressable
          onPress={() => { if (!selectMode) enterSelectMode() }}
          style={{
            flexShrink: 0,
            width: '42px',
            height: '42px',
            borderRadius: '50%',
            border: 'var(--border-glass)',
            background: 'var(--glass-bg)',
            backdropFilter: 'saturate(var(--glass-saturation)) blur(var(--glass-blur))',
            WebkitBackdropFilter: 'saturate(var(--glass-saturation)) blur(var(--glass-blur))',
            color: '#fff',
            cursor: selectMode ? 'default' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
            boxShadow: 'var(--glass-shadow)',
          }}
          title="Select"
        >
          <SelectListIcon size={17} />
        </Pressable>
      )}
    </div>
  )

  const filterTabsBar = (
    <div className="no-sb" style={{ display: 'flex', gap: '6px', overflowX: 'auto', paddingBottom: '14px' }}>
      {filterTabConfig.map(({ key, label, icon: Icon }) => {
        const isActive = libraryFilter === key
        return (
          <Pressable
            key={key}
            onPress={() => setLibraryFilter(key)}
            pressScale={0.94}
            style={{
              height: '40px',
              padding: isActive ? '0 18px' : '0 24px',
              borderRadius: '100px',
              border: 'none',
              background: isActive ? '#007bff' : '#303030',
              color: isActive ? '#ffffff' : '#b0b0b0',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: isActive ? '8px' : '0',
              flexShrink: 0,
              transition: 'padding 0.3s cubic-bezier(0.34, 1.3, 0.64, 1), background 0.25s ease, color 0.25s ease, gap 0.3s cubic-bezier(0.34, 1.3, 0.64, 1)',
              overflow: 'hidden',
            }}
          >
            <Icon size={18} />
            {isActive && (
              <span style={{
                fontSize: '15px',
                fontWeight: '600',
                whiteSpace: 'nowrap',
                fontFamily: 'var(--font-system)',
                animation: 'lib-pill-label 0.3s cubic-bezier(0.34, 1.3, 0.64, 1)',
              }}>
                {label}
              </span>
            )}
          </Pressable>
        )
      })}
    </div>
  )

  /* ── Floating select-mode controls: ONE glass pill holding X + ⋯.
   *    Sits at the SAME vertical spot as the nav bar (which is hidden in
   *    select mode), but shifted to the right side. Matches the nav bar's
   *    liquid-glass look. ── */
  const selectControls = selectMode && (
    <div style={{
      position: 'fixed',
      right: '16px',
      bottom: 'calc(env(safe-area-inset-bottom, 0px) + 16px)',  // same line as nav bar
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '12px',
      zIndex: 1500,
    }}>
      {/* Action card (Star/Unfavourite + Delete) — appears ABOVE the pill */}
      {showActionCard && (
        <div style={{
          minWidth: '210px',
          background: 'rgba(22,22,24,0.6)',
          border: '1px solid rgba(121,121,121,0.5)',
          borderRadius: '18px',
          backdropFilter: 'saturate(180%) blur(30px)',
          WebkitBackdropFilter: 'saturate(180%) blur(30px)',
          boxShadow: '0 10px 40px rgba(0,0,0,0.55)',
          overflow: 'hidden',
          marginBottom: '4px',
          transformOrigin: 'bottom right',
          animation: 'lib-card-in 0.3s cubic-bezier(0.34, 1.4, 0.64, 1)',
        }}>
          <Pressable
            onPress={handleStarSelected}
            disabled={selectedCount === 0 || starAnimating}
            pressScale={0.97}
            style={actionRowStyle(selectedCount === 0)}
          >
            <span style={{ display: 'flex', width: '24px', justifyContent: 'center' }}>
              {(allSelectedFav ? !starFilled : starFilled)
                ? <StarFilledIcon size={20} />
                : <StarOutlineIcon size={20} />}
            </span>
            <span style={{ flex: 1, textAlign: 'left' }}>
              {allSelectedFav ? 'Unfavourite' : (starFilled ? 'Favourited' : 'Favourite')}
            </span>
          </Pressable>
          <div style={{ height: '0.5px', background: 'rgba(255,255,255,0.12)', marginLeft: '16px' }} />
          <Pressable
            onPress={handleDeleteSelected}
            disabled={selectedCount === 0}
            pressScale={0.97}
            style={{ ...actionRowStyle(selectedCount === 0), color: '#FF453A' }}
          >
            <span style={{ display: 'flex', width: '24px', justifyContent: 'center' }}><TrashOutlineIcon size={20} /></span>
            <span style={{ flex: 1, textAlign: 'left' }}>Delete</span>
          </Pressable>
        </div>
      )}

      {/* The single pill: X (cancel) + ⋯ (actions) — same liquid glass as the
          nav bar, never turns blue. */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: '4px',
        padding: '6px',
        borderRadius: '100px',
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'saturate(130%) blur(3px)',
        WebkitBackdropFilter: 'saturate(130%) blur(3px)',
        border: '0.5px solid rgba(255, 255, 255, 0.08)',
        boxShadow: '0 8px 28px rgba(0,0,0,0.22), inset 0 0.5px 0 rgba(255,255,255,0.18)',
      }}>
        <Pressable onPress={exitSelectMode} style={pillBtnStyle} title="Cancel">
          <XMarkIcon size={16} />
        </Pressable>
        <Pressable
          onPress={() => setShowActionCard(s => { const next = !s; if (next) setStarFilled(false); return next })}
          style={pillBtnStyle}
          title="Actions"
        >
          <EllipsisIcon size={18} />
        </Pressable>
      </div>
    </div>
  )

  /* ── Delete confirm notice — identical styling to DeleteConfirm.js ── */
  const deleteConfirmNotice = confirmDelete && (
    <div
      style={{ position: 'fixed', inset: 0, background: 'rgba(0, 0, 0, 0.4)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999, padding: '20px' }}
      onClick={() => setConfirmDelete(false)}
    >
      <div className="animate-slide-up" style={{
        background: 'rgba(255, 255, 255, 0.06)',
        backdropFilter: 'saturate(180%) blur(50px)',
        WebkitBackdropFilter: 'saturate(180%) blur(50px)',
        border: '0.5px solid rgba(255, 255, 255, 0.15)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3), inset 0 0.5px 0 rgba(255, 255, 255, 0.15), inset 0 -0.5px 0 rgba(0, 0, 0, 0.05)',
        borderRadius: 'var(--radius-2xl)',
        padding: '32px 24px 24px',
        maxWidth: '340px',
        width: '100%',
      }} onClick={e => e.stopPropagation()}>
        <p style={{ fontSize: 'var(--text-lg)', lineHeight: 'var(--leading-relaxed)', textAlign: 'left', marginBottom: '24px', color: 'var(--color-text-primary)' }}>
          This log will be permanently deleted and cannot be restored.
        </p>
        <button
          onClick={() => { setDeleteAnimating(true); setTimeout(() => { setDeleteAnimating(false); confirmDeleteSelected() }, 180) }}
          style={{
            width: '100%',
            padding: '16px',
            background: 'rgba(255, 255, 255, 0.05)',
            border: '0.5px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '100px',
            color: 'var(--color-danger)',
            fontSize: 'var(--text-lg)',
            fontWeight: 'var(--weight-semibold)',
            cursor: 'pointer',
            transform: deleteAnimating ? 'scale(0.95)' : 'scale(1)',
            transition: 'transform 0.18s var(--ease-spring)',
            fontFamily: 'var(--font-system)',
          }}>
          Delete
        </button>
      </div>
    </div>
  )

  const libAnimStyles = (
    <style>{`
      @keyframes lib-pill-label { from { opacity: 0; transform: translateX(-4px); } to { opacity: 1; transform: translateX(0); } }
      @keyframes lib-clear-in { from { opacity: 0; transform: scale(0.5); } to { opacity: 1; transform: scale(1); } }
      @keyframes lib-card-in { from { opacity: 0; transform: scale(0.88) translateY(8px); } to { opacity: 1; transform: scale(1) translateY(0); } }
    `}</style>
  )

  if (libraryFilter === 'Media') return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
      {libAnimStyles}
      <div style={{ flexShrink: 0, paddingTop: '48px', background: 'var(--color-bg-app)', zIndex: 10, position: 'relative' }}>
        <div className="app-content">
          <h1 style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--weight-bold)', marginBottom: '16px', color: 'var(--color-text-primary)' }}>Library</h1>
          {searchBar}
          {filterTabsBar}
        </div>
      </div>
      <div className="app-content no-sb" ref={libraryScrollRef} style={{ flex: 1, overflowY: 'auto' }}>
        <div style={{ paddingBottom: '84px', paddingTop: '2px' }}>
          {mediaGridItems.length === 0
            ? <p style={{ color: 'var(--color-text-secondary)', textAlign: 'center', marginTop: '60px' }}>No media yet</p>
            : <>
                <div className="media-grid" style={{ width: '100%' }}>
                  {mediaGridItems.map((item, idx) => (
                    <div key={idx} className="media-grid-item"
                      onClick={() => {
                        const allUrls = mediaGridItems.map(i => i.url)
                        const allLogs = mediaGridItems.map(i => i.log)
                        if (allUrls.length > 1) onGalleryClick({ urls: allUrls, index: idx, log: item.log, logsMap: allLogs })
                        else if (item.isVideo) onVideoClick({ url: item.url, log: item.log })
                        else onImageClick({ url: item.url, log: item.log })
                      }}>
                     {item.isVideo
                     ? <><video src={item.url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} muted playsInline />
                    <div style={{ position: 'absolute', bottom: '4px', right: '6px' }}><svg width="10" height="11" viewBox="0 0 10 11" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 9.22852V0.955078C0 0.310547 0.380859 0 0.832031 0C1.03125 0 1.23633 0.0585938 1.43555 0.169922L8.35547 4.21289C8.85938 4.50586 9.06445 4.72852 9.06445 5.0918C9.06445 5.44922 8.85938 5.67773 8.35547 5.9707L1.43555 10.0078C1.23633 10.1191 1.03125 10.1777 0.832031 10.1777C0.380859 10.1777 0 9.86719 0 9.22852Z" fill="white"/></svg></div></>
                    : <img src={item.url} alt="" loading="lazy" />
                      }
                    </div>
                  ))}
                </div>
                <p style={{ color: 'var(--color-text-secondary)', fontSize: 'var(--text-sm)', textAlign: 'center', marginTop: '16px', marginBottom: '8px' }}>
                  {mediaPhotos > 0 && `${mediaPhotos} Photo${mediaPhotos !== 1 ? 's' : ''}`}
                  {mediaPhotos > 0 && mediaVideos > 0 && '  ·  '}
                  {mediaVideos > 0 && `${mediaVideos} Video${mediaVideos !== 1 ? 's' : ''}`}
                </p>
              </>
          }
        </div>
      </div>
    </div>
  )

  return (
    <div className="app-content no-sb" ref={libraryScrollRef} style={{ height: '100vh', overflowY: 'auto' }}>
      {libAnimStyles}
      <h1 style={{ fontSize: 'var(--text-3xl)', fontWeight: 'var(--weight-bold)', marginBottom: '16px', paddingTop: '48px', color: 'var(--color-text-primary)' }}>Library</h1>
      {searchBar}
      {filterTabsBar}
      <div className="feed-wrap" style={{ paddingBottom: selectMode ? '160px' : undefined }}>
        {filteredLogs.length === 0 && <p style={{ color: 'var(--color-text-secondary)', textAlign: 'center', marginTop: '60px' }}>Nothing here yet</p>}
        {filteredLogs.map(log => (
          <SwipeableLogItem key={log.id} log={log}
            onDelete={() => onDeleteConfirm(log)}
            onStar={() => (onToggleLogStarFull ? onToggleLogStarFull(log.id) : onToggleStar(log.id, log.is_starred))}
            renderContent={renderLogContent}
            getLogIcon={getLogIcon}
            formatTimestamp={formatTimestamp}
            selectMode={selectMode}
            selected={selectedIds.has(log.id)}
            onToggleSelect={() => toggleSelect(log.id)}
          />
        ))}
      </div>

      {selectControls}
      {deleteConfirmNotice}
    </div>
  )
}

/* Round button inside the floating select pill */
const pillBtnStyle = {
  width: '44px',
  height: '44px',
  borderRadius: '50%',
  background: 'transparent',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 0,
  WebkitTapHighlightColor: 'transparent',
}

/* Action-card row style helper */
function actionRowStyle(disabled) {
  return {
    width: '100%',
    height: '48px',
    background: 'none',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '0 18px',
    color: '#fff',
    fontSize: '16px',
    fontFamily: 'var(--font-system)',
    cursor: disabled ? 'default' : 'pointer',
    opacity: disabled ? 0.4 : 1,
  }
}

export default LibraryPage